import { useDocItems } from '@modules/docs/providers';
import { Badge, Tooltip } from '@mui/material';
import cn from 'classnames';
import { MouseEvent, useMemo } from 'react';
import Iconify from 'src/components/iconify';
import { ActionsBarButtonStyled, StyledListContainer } from '../shared/styles';
import { useActionBarState } from '../useActionBarState';
import { useDocsActionBarState } from './useDocsActionBarState';
import { useDocsActionBarUIState } from './useDocsActionBarUIState';

export const DocsActionBar = ({
  showBorder,
  onClick,
}: { showBorder?: boolean; onClick: () => void }) => {
  const { openAction, setReopen, isOpen, setIsOpen } = useActionBarState();
  const { docId: openedDocId, setDoc } = useDocsActionBarState();
  const { docsIDList, deleteDocFromList } = useDocsActionBarUIState();

  const { docs } = useDocItems();

  const docsList = useMemo(() => {
    if (!docs?.length) return [];
    return docs.filter((doc) => docsIDList.includes(doc._id));
  }, [docs, docsIDList]);

  const handleOpenDoc = (
    event: MouseEvent<HTMLButtonElement>,
    docId: string,
  ) => {
    event.stopPropagation();
    if (openedDocId === docId) return onClick();
    setDoc(docId);
    if (isOpen) {
      setReopen('doc');
      setIsOpen(false);
    } else {
      onClick();
    }
  };

  const handleCloseDoc = (docId: string) => {
    deleteDocFromList(docId);
    if (!openedDocId || openedDocId !== docId) return;
    setIsOpen(false);
  };

  if (!docsList.length) return null;

  return (
    <StyledListContainer className={cn({ showBorder })}>
      {docsList?.map((doc) => (
        <Tooltip title={doc.title} placement="left" key={doc._id} arrow>
          <Badge
            onClick={() => handleCloseDoc(doc._id)}
            badgeContent="x"
            color="primary"
            sx={{ cursor: 'pointer' }}
          >
            <ActionsBarButtonStyled
              variant="outlined"
              color={
                openAction === 'doc' && openedDocId === doc._id
                  ? 'primary'
                  : 'inherit'
              }
              onClick={(e) => handleOpenDoc(e, doc._id)}
            >
              <Iconify icon="tabler:file-text" />
            </ActionsBarButtonStyled>
          </Badge>
        </Tooltip>
      ))}
    </StyledListContainer>
  );
};
